import React from 'react';

import type { PublicCommands, TFunction } from './../../ricos-types';

import { getCustomHeadingsLabel, headingsMap, translateHeading } from '../heading';

export const getCurrentHeadingIcon =
  (allowHeadingCustomization: boolean) =>
  (publicCommands: PublicCommands, t: TFunction): ((props: $TSFixMe) => JSX.Element) => {
    const selectedHeading = publicCommands.getCurrentHeading();
    let Label: $TSFixMe;
    if (allowHeadingCustomization) {
      Label = getCustomHeadingsLabel(selectedHeading, t, publicCommands);
    } else {
      Label = translateHeading(headingsMap[selectedHeading as $TSFixMeKey<typeof headingsMap>], t);
    }
    return () => <div>{Label}</div>;
  };
